export const getUserInfoFromCookie = (cookieStore = document.cookie) => {
  try {
    const wixClient = cookieStore.split(';').find((s) => s.includes('wixClient'));
    if (!wixClient) {
      return {};
    }

    const info = wixClient.split('=')[1].replace(/^"|"$/g, '').split('|');

    return { name: info[0], userId: info[6] };
  } catch (ex) {
    console.warn('Cannot parse wixClient cookie', ex);
    return {};
  }
};
